module.exports = __webpack_public_path__ + "static/media/carousel2.51c20e1c.jpg";